const __request = require(`./__request/__request_contentType_json`);

// 行程单打印详情保存
const recordCount = (data) => {
let pParameter = {
    method: 'post',
    // urlSuffix: '/flight/domestic/buyer/manage/itineraryOrder/pdfParam',
    urlSuffix:'/buyer/dom/manage/itinerary/save/detail',
    data:data
  }

  return __request(pParameter)
}
export default recordCount
